<!-- Esqueleto de carga: vive aquí y no en el contenedor para heredar la geometría REAL de la franja
     y de la banda —mismas clases, mismos anchos—, así lo que aparece al llegar el libro no salta. -->
<ng-container *ngIf="loading; else contenido">
  <div class="ls-strip" aria-busy="true" aria-label="Cargando el estado del arrendamiento">
    <div class="ls-tile" *ngFor="let t of [1, 2, 3, 4]; let i = index" [class.is-act]="i === 2">
      <div class="ls-act-head">
        <p-skeleton height="0.72rem" width="7.5rem"></p-skeleton>
        <p-skeleton *ngIf="i === 2" height="1.35rem" width="5.5rem" borderRadius="6px"></p-skeleton>
      </div>
      <p-skeleton height="1.375rem" width="9rem"></p-skeleton>
      <p-skeleton height="0.75rem" width="100%"></p-skeleton>
    </div>
  </div>

  <div class="ls-quality" aria-busy="true" aria-label="Cargando el comportamiento de pago">
    <div class="ls-who">
      <p-skeleton width="2.75rem" height="2.75rem" borderRadius="10px"></p-skeleton>
      <div class="ls-sk-lines">
        <p-skeleton height="0.8rem" width="11rem"></p-skeleton>
        <p-skeleton height="0.72rem" width="8rem"></p-skeleton>
      </div>
    </div>
    <div class="ls-metrics">
      <div class="ls-m" *ngFor="let m of [1, 2, 3, 4, 5]">
        <p-skeleton height="0.68rem" width="70%"></p-skeleton>
        <p-skeleton height="1.15rem" width="55%"></p-skeleton>
        <p-skeleton height="0.68rem" width="85%"></p-skeleton>
      </div>
    </div>
    <div class="ls-spark-wrap">
      <div class="ls-spark-cap">
        <p-skeleton height="0.68rem" width="8rem"></p-skeleton>
        <p-skeleton height="0.68rem" width="4rem"></p-skeleton>
      </div>
      <!-- Alturas fijas: una silueta de gráfica, sin fingir que son los días de nadie. -->
      <div class="ls-spark ls-sk-spark">
        <p-skeleton *ngFor="let h of sparkSkeleton" class="ls-sk-bar" width="100%" [height]="h + '%'"></p-skeleton>
      </div>
      <div class="ls-spark-x">
        <p-skeleton *ngFor="let h of sparkSkeleton" class="ls-sk-bar" height="0.6rem" width="100%"></p-skeleton>
      </div>
    </div>
  </div>
</ng-container>

<ng-template #contenido>
  <!-- Franja de estado: UNA caja con cuatro casillas separadas por su borde, como el diseño aprobado.
     Antes eran cuatro tarjetas flotantes con sombra; se leían como cuatro objetos y no como el
     estado del arrendamiento. -->
  <div class="ls-strip">
    <div class="ls-tile">
      <div class="ls-lbl">Vencido a hoy</div>
      <div class="ls-val" [class.is-bad]="totals.overdueAmount > 0">{{ totals.overdueAmount | currency }}</div>
      <div class="ls-sub">
        <b>{{ totals.overdueCount }}</b> {{ totals.overdueCount === 1 ? 'letra' : 'letras'
        }}<ng-container *ngIf="oldestOverdueDays > 0">
          · la más antigua lleva <b>{{ oldestOverdueDays }} días</b></ng-container
        >
      </div>
    </div>

    <div class="ls-tile">
      <div class="ls-lbl">
        Mora devengada <span class="ls-mini-tag" *ngIf="moraPaused"><i class="pi pi-pause"></i> en pausa</span>
      </div>
      <div class="ls-val">{{ totals.accruedMora | currency }}</div>
      <div class="ls-sub">
        pendiente de cobro a hoy · <b>{{ moraPaidTotal | currency }}</b> cobrada
      </div>
    </div>

    <!-- Casilla de acción: es la única sombreada porque es la única desde la que se opera. -->
    <div class="ls-tile is-act">
      <!-- La acción va arriba, en la esquina de SU casilla, no colgando debajo: un botón al pie estiraba
         la fila entera y dejaba a las otras tres casillas con un hueco al final que no era de nadie.
         Lo que el rótulo perdió al acortarse («con previsualización») lo dice el tooltip. -->
      <div class="ls-act-head">
        <div class="ls-lbl">Por aplicar del cliente</div>
        <!-- `readOnly` va ANTES del permiso: una vista que no opera no ofrece la acción a nadie. -->
        <ng-container *ngIf="!readOnly">
          <ng-container *appIfHasPermission="['applications', 'create']">
            <button
              *ngIf="unappliedAmount > 0 && !residualOnly"
              pButton
              type="button"
              label="Aplicar"
              icon="pi pi-play"
              pTooltip="Aplicar con previsualización del impacto"
              tooltipPosition="top"
              class="p-button-sm ls-cta"
              (click)="apply.emit()"
            ></button>
            <button
              *ngIf="residualOnly"
              pButton
              type="button"
              label="Al residual"
              icon="pi pi-flag-fill"
              pTooltip="Aplicar al residual, con previsualización del impacto"
              tooltipPosition="top"
              class="p-button-sm p-button-outlined ls-cta-ghost"
              (click)="residual.emit()"
            ></button>
          </ng-container>
        </ng-container>
      </div>
      <div class="ls-val">{{ unappliedAmount | currency }}</div>
      <div class="ls-sub" *ngIf="unapplied.length; else sinPorAplicar">
        <b>{{ unapplied.length }}</b> {{ unapplied.length === 1 ? 'pago' : 'pagos' }} sin aplicar<ng-container
          *ngIf="oldestUnappliedPaidOn"
        >
          · pagó el <b>{{ oldestUnappliedPaidOn | date: 'dd/MM/yyyy' : 'UTC' }}</b></ng-container
        >
        <span
          class="ls-twin"
          *ngIf="hasTwins"
          tabindex="0"
          aria-label="Algún pago sin aplicar tiene un gemelo: evidencia, no veredicto"
          pTooltip="Algún pago sin aplicar tiene un gemelo: evidencia, no veredicto. Ábrelo desde Por pago o desde la letra."
          tooltipPosition="top"
          >posible duplicado</span
        >
      </div>
      <ng-template #sinPorAplicar><div class="ls-sub">Sin pagos pendientes de aplicar</div></ng-template>
    </div>

    <div class="ls-tile">
      <div class="ls-lbl">Próximo vencimiento</div>
      <ng-container *ngIf="totals.nextDue; else sinProximo">
        <!-- El dato grande es la FECHA: lo que se pregunta de un vencimiento es cuándo, no cuánto. -->
        <div class="ls-val">{{ totals.nextDue.date | date: 'dd/MM/yyyy' : 'UTC' }}</div>
        <div class="ls-sub">
          letra <b>{{ totals.nextDue.n }}</b
          ><ng-container *ngIf="daysToNextDue !== null">
            · <b>{{ daysToNextDue >= 0 ? 'en ' + daysToNextDue + ' días' : 'hace ' + -daysToNextDue + ' días' }}</b></ng-container
          >
          · {{ totals.nextDue.amount | currency }}
        </div>
      </ng-container>
      <ng-template #sinProximo>
        <div class="ls-val">—</div>
        <div class="ls-sub">Sin letras por vencer</div>
      </ng-template>
    </div>
  </div>

  <!-- Comportamiento de pago del cliente: calificación · cinco métricas con su contexto · barras por letra -->
  <div class="ls-quality">
    <div class="ls-who">
      <span
        class="ls-grade"
        [ngClass]="'is-' + (quality?.grade || 'none')"
        [pTooltip]="
          quality?.grade ? 'Calificación según la matriz de Cartera › Configuración' : 'Sin letras cubiertas todavía: no hay calificación'
        "
        tooltipPosition="top"
        >{{ quality?.grade || '—' }}</span
      >
      <div>
        <div class="ls-who-t">Comportamiento de pago del cliente</div>
        <div class="ls-who-s">
          <ng-container *ngIf="quality; else sinLetras">Últimas {{ quality.paidPeriods }} letras pagadas</ng-container>
          <ng-template #sinLetras>Sin letras cubiertas</ng-template>
          <ng-container *appIfHasPermission="['wallet', 'get-all']">
            · <a routerLink="/wallet-config">ver reglas de calificación</a></ng-container
          >
        </div>
      </div>
    </div>

    <div class="ls-metrics">
      <div class="ls-m">
        <span class="ls-m-l">Puntualidad</span>
        <span class="ls-m-v">{{ quality ? (quality.onTimeRate | percent: '1.0-0') : '—' }}</span>
        <span class="ls-m-s">{{ quality ? quality.onTime + ' de ' + quality.paidPeriods + ' letras a tiempo' : 'sin dato' }}</span>
      </div>
      <div class="ls-m">
        <span class="ls-m-l">Retraso promedio</span>
        <span class="ls-m-v">{{ quality ? (quality.avgDelayDays | number: '1.0-1') + ' d' : '—' }}</span>
        <span class="ls-m-s">{{ quality ? 'máximo ' + quality.maxDelayDays + ' d' : 'sin dato' }}</span>
      </div>
      <div class="ls-m">
        <span class="ls-m-l">Vencidas hoy</span>
        <span class="ls-m-v" [class.is-bad]="totals.overdueCount > 0">{{ totals.overdueCount }}</span>
        <span class="ls-m-s">{{ oldestOverdueDays > 0 ? 'la más antigua, ' + oldestOverdueDays + ' d' : 'ninguna' }}</span>
      </div>
      <div class="ls-m">
        <span class="ls-m-l">Mora cobrada</span>
        <span class="ls-m-v">{{ quality?.moraPaid || 0 | currency }}</span>
        <span class="ls-m-s">condonada {{ quality?.moraWaived || 0 | currency }}</span>
      </div>
      <div class="ls-m">
        <span class="ls-m-l">Registro tardío</span>
        <span class="ls-m-v">{{ quality ? (quality.avgRegistrationLagDays | number: '1.0-1') + ' d' : '—' }}</span>
        <span class="ls-m-s">promedio nuestro, por pago</span>
      </div>
    </div>

    <!-- Barras por letra: el dato también va en texto (aria-label) porque un span con title no llega por teclado -->
    <div class="ls-spark-wrap" *ngIf="sparkBars.length">
      <div class="ls-spark-cap"><span>Días de retraso por letra</span><span>rojo = abierta</span></div>
      <div class="ls-spark" role="list" [attr.aria-label]="sparkBars.length + ' letras con retraso medido; rojo = letra abierta'">
        <span
          *ngFor="let b of sparkBars"
          role="listitem"
          tabindex="0"
          class="ls-bar"
          [class.is-open]="b.open"
          [class.is-zero]="!b.open && b.days === 0"
          [style.height.%]="b.height"
          [attr.aria-label]="
            'Letra ' +
            b.n +
            ' · ' +
            (b.open ? b.days + ' días vencida' : b.days ? 'pagada con ' + b.days + ' días de retraso' : 'pagada a tiempo')
          "
          [attr.title]="'Letra ' + b.n + ' · ' + b.days + ' d'"
        ></span>
      </div>
      <div class="ls-spark-x">
        <span *ngFor="let b of sparkBars">{{ b.n }}</span>
      </div>
    </div>
  </div>
</ng-template>
